/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import Checklist from "vux/src/components/checklist/index.vue";
import ScrollerList from '@/components/ScrollerList';
import SearchBar from '@/components/SearchBar';
import Tags from '@/components/Tags';
import { getMakeTagList, orderAddTag } from '@/api';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    ScrollerList: ScrollerList,
    SearchBar: SearchBar,
    Checklist: Checklist,
    Tags: Tags
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: String
  },
  data: function data() {
    return {
      checklist: [],
      tagList: [],
      list: [],
      originlist: [],
      restaglist: [],
      labelPosition: '',
      currValue: this.value,
      keyword: '',
      loading: false
    };
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      var _this2 = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this2.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }

      this.$emit('input', val);
    }
  },
  methods: {
    loadList: function loadList() {
      var _this3 = this;

      var _this = this;

      getMakeTagList({
        oid: _this.orderId
      }).then(function (res) {
        if (!res.success) return _this3.$vux.toast.text(res.message);
        var temlist = [];
        _this3.restaglist = res.data;
        res.data.forEach(function (item) {
          var tem = {};
          tem['key'] = item['id'];
          tem['value'] = item['name'];
          tem['color_rgb'] = item['color_rgb'];
          tem['hasTag'] = item['hasTag'];

          if (item['hasTag'] === 1) {
            _this3.originlist.push(item);

            _this3.checklist.push(item['id']);
          }

          temlist.push(tem);
        });
        _this.list = _this.list.concat(temlist);
        _this.tagList = _this.tagList.concat(temlist);
      });
    },
    resetList: function resetList() {
      var _this4 = this;

      var tem = [];
      this.list && this.list.forEach(function (item) {
        if (item['value'].indexOf(_this4.keyword) !== -1) {
          tem.push(item);
        }
      });
      this.tagList = tem;
    },
    // 改变checkbox回调
    change: function change(val, label) {
      var curcheckd = _toConsumableArray(this.restaglist.filter(function (item) {
        if (val.indexOf(item['id']) > -1) {
          return true;
        }
      }));

      this.originlist = curcheckd;
    },
    removeTag: function removeTag(tagId) {
      var index = this.checklist.indexOf(tagId);

      if (index > -1) {
        this.checklist.splice(index, 1);
      }

      this.originlist = _toConsumableArray(this.originlist.filter(function (item) {
        if (item['id'] !== tagId) {
          return true;
        }
      }));
    },
    submit: function submit() {
      var _this5 = this;

      var _this = this;

      this.loading = true;
      orderAddTag({
        tagIds: _this.checklist,
        oid: _this.orderId
      }).then(function (res) {
        _this5.loading = false;

        if (res.success) {
          var temtaglsit = [];

          _this.restaglist.forEach(function (item) {
            if (_this.checklist.indexOf(item['id']) > -1) {
              temtaglsit.push(item);
            }
          });

          _this.$vux.toast.text('打标成功');

          _this.$emit('on-success', temtaglsit);

          _this.currValue = false;
        } else {
          _this.$vux.toast.text(res.message);
        }
      });
    }
  },
  created: function created() {
    this.loadList();
  }
};